/**
 * @mixin
 */
module.exports = {
  props: {
    /** 本组件需要用上的接口
     * @values {list,delete,deleteAll,export,add,edit,detail,path,tree}
     */
    api: {
      type: Object,
      default: null,
      required: true,
    },
    /** 表头
     * @values {prop,label,width,scopeFun:function,scopeComponent,scope,custom}
     */
    columns: {
      type: Array,
      default: () => {
        return [];
      },
      required: true,
    },
    /** 请求列表数据时外部出入的参数
     */
    tableParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    /** 请求列表数据之前对请求参数的操作 */
    beforeGet: {
      type: Function,
      default: null,
    },
    /** 请求列表数据成功之后对列表数据的操作*/
    afterGet: {
      type: Function,
      default: null,
    },
    /** 表格行key的取值 */
    rowKey: {
      type: String,
      default: "id",
    },
    /** 是否显示列表的选择*/
    selection: {
      type: Boolean,
      default: false,
    },
    /** 是否显示列表的操作列*/
    actionColumn: {
      type: Boolean,
      default: true,
    },
    /** 列表内默认的按钮*/
    columnBtns: {
      type: Object,
      default: () => {
        return {
          detail: false,
          edit: true,
          delete: true,
        };
      },
    },
  },
};
